import { useTranslation } from "@opendash/i18n";
import { Form, Input } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { StepsExecuteFormValues, StepsObjectInScheduleExecution } from "..";

const { TextArea } = Input;

export default observer(
  (props: {
    step: StepsObjectInScheduleExecution;
    onChange: (values: StepsExecuteFormValues) => void;
  }) => {
    const t = useTranslation();
    const [form] = Form.useForm();

    return (
      <Form
        form={form}
        onValuesChange={(changedValues, allValues: StepsExecuteFormValues) => {
          props.onChange({
            comment: allValues[props.step.id + "_comment"],
            done: props.step.done, // Keep the current done state, only update comment
          });
        }}
      >
        {/* Switch entfernt - wird jetzt prominent in StepsExecuteContainer angezeigt */}

        <Form.Item
          label={t("maintenance:schedules.steps.table.execute.form.comment")}
          name={props.step.id + "_comment"}
          initialValue={props.step.comment}
        >
          <TextArea
            disabled={props.step.done}
            rows={4}
            placeholder={
              props.step.done
                ? "Kommentar kann nicht bearbeitet werden - Schritt ist bereits abgehakt"
                : t("maintenance:schedules.steps.table.execute.form.comment")
            }
          />
        </Form.Item>
      </Form>
    );
  }
);
